import React from "react";

import { FormField, Text } from "@performyard/py-components";

import { GridCol } from "../../../../components/Grid";
import InputTextArea from "../../../../components/Inputs/InputTextArea";
import Spacer from "../../../../components/Spacer";

type GuidelinesFieldProps = {
	id: string;
	dataTestId?: string;
	label: string;
	description: string;
};

export const GuidelinesField = ({ id, dataTestId, label, description }: GuidelinesFieldProps) => {
	return (
		<GridCol span={5}>
			<FormField<string>
				id={id}
				labelPosition="top"
				label={
					<>
						<Text size="paragraph-2" weight="semi-bold" color="neutral-9">
							{label}
						</Text>
						<Spacer height={1} />
						<div>
							<Text size="paragraph-3" weight="regular" color="neutral-9">
								{description}
							</Text>
						</div>
					</>
				}
				input={(field) => (
					<InputTextArea
						id={id}
						value={field.value ?? ""}
						onChange={field.onChange}
						minRows={4}
						maxRows={10}
						errored={Boolean(field.errors?.length)}
						testId={dataTestId}
					/>
				)}
			/>
		</GridCol>
	);
};
